import {ACTION_TYPES, createAction} from "../actions";
import {put, takeEvery} from 'redux-saga/effects'
import {IFeature_CONO} from "../../types";

export function* createFeatureSaga () {
    yield takeEvery(ACTION_TYPES.CREATE_FEATURE, _createFeature);
}

function* _createFeature (action: any) {
    const payload: {geo_type: string, type: string, fullUid: string, feature: IFeature_CONO} = action.payload;
    try {
        yield put(createAction(ACTION_TYPES.CREATE_ENTITY_GEOMETRY, payload));
    } catch (error) {
        yield put(createAction(ACTION_TYPES.CREATE_FEATURE_ERROR, {error}));
    }
}
